import { forwardRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TextArea = forwardRef(({value, onChange,onKeyDown, onInput, disabled = false,autoComplete = "off",minHeight = "35px",
  maxHeight = "200px"}, ref) => {
    
  const [t,] = useTranslation('global');

  const adjustHeight = () => {
    const textarea = ref.current;
    if (!textarea) return;
    
    const scrollPos = textarea.scrollTop;
    textarea.style.height = minHeight;
    
    const newHeight = Math.min(
      Math.max(textarea.scrollHeight, parseInt(minHeight)),
      parseInt(maxHeight)
    );
    
    textarea.style.height = `${newHeight}px`;
    
    if (newHeight === parseInt(maxHeight)) {
      textarea.scrollTop = scrollPos;
    }
  };

  // Adjust height when value changes
  useEffect(() => {
    adjustHeight();
  }, [value]);

  const handleInput = (e) => {
    if (onInput) {
      onInput(e);
    }
    adjustHeight();
  };

  // const handleKeyDown = (e) => {
  //   if (e.key === 'Enter' && !e.shiftKey) {
  //     e.preventDefault(); // Prevent new line
  //     if (onEnterPress) {
  //       onEnterPress(e);
  //     }
  //   }
    
  //   // Call the original onKeyDown if provided
  //   if (onKeyDown) {
  //     onKeyDown(e);
  //   }
  // };

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onInput={handleInput}
      disabled={disabled}
      autoComplete={autoComplete}
      placeholder={t('enterMessage')}
      className="mill-textarea"
    />
  );
});

TextArea.displayName = 'TextArea';

export default TextArea;